import { render } from "./OratorPrepView.vue?vue&type=template&id=fc3584fc&scoped=true"
import script from "./OratorPrepView.vue?vue&type=script&lang=js"
export * from "./OratorPrepView.vue?vue&type=script&lang=js"

import "./OratorPrepView.vue?vue&type=style&index=0&id=fc3584fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc3584fc"]])

export default __exports__